export default "__VITE_ASSET__7PQqBMQY__"